import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {toast} from "react-custom-alert";
import { Spinner } from 'react-bootstrap';

const SendConfirmation = ({customToken, receiptFile, ...props}: ModalProps)  => {
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    const location = useLocation();
    const{getAppUniqueToken} = useAppUniqueToken();
    const [uaToken, setUaToken] = useState(getAppUniqueToken);
    const navigate = useNavigate();

    useEffect(() => {
        if(customToken)
            setUaToken(customToken);
    }, [customToken])


    const handleConfirm = async () => {
        setIsLoading(true);
        const payload = new FormData();
        payload.append("uaToken", uaToken);
        if (receiptFile instanceof File) {
            payload.append("receiptFile", receiptFile);
        }
        try {
            await axios.post('/api/send', payload, { headers: { "Accept": "application/json" } });
            if (location.pathname === '/summary')
                navigate('/success');
            else
                window.location.reload();
        } catch (error: unknown) {
            setIsLoading(false);
            const ax = error as { response?: { data?: unknown } };
            const backendMessage = ax.response?.data && typeof ax.response.data === 'object' && ax.response.data !== null && 'message' in ax.response.data
                ? (ax.response.data as { message?: string }).message
                : null;
            toast.error(backendMessage || t('messages.defaultErrorMessage'));
        }
    };


    return (

        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <h4>Conferma invio</h4> <br />
                Con questa operazione invierai le tue richieste di adesione a Europa Verde - Verdi<br /><br />
            </Modal.Body>
            <Modal.Footer>
                <button 
                    type="button" 
                    className="btn_1 green" 
                    onClick={handleConfirm}
                    disabled={isLoading}
                >
                {
                    isLoading ? (
                    <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    ) : (
                        t('captions.confirm')
                    )
                }
                </button>
                <button type="button" className="btn_1 yellow" onClick={props.onHide} disabled={isLoading}>{t('captions.cancel')}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default SendConfirmation;
